import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { FilterCollection, FilterName } from '@/stores/filter.store';

const INITIAL_FILTERS = {
	providers: [],
	content_types: [],
	min_price: null,
	max_price: null,
	scoring_filter_types: null,
	monetization_types: [],
} as Partial<FilterCollection>;

// STATE
const state = {
	isFetching: false,
	filters: { ...INITIAL_FILTERS },
};

// GETTERS
const getters: GetterTree<typeof state, any> = {
	isAnyFilterActive:
		(state, getters) =>
		(keys = Object.keys(INITIAL_FILTERS)) => {
			return (
				Object.keys(state.filters)
					.filter(key => keys.indexOf(key as any) !== -1)
					.map(key => (state.filters as any)[key])
					.filter(item => {
						return (Array.isArray(item) && item.length > 0) || (!Array.isArray(item) && item);
					}).length > 0
			);
		},
};

// ACTIONS
const actions: ActionTree<typeof state, any> = {
	resetFilters({ commit }) {
		(Object.keys(state.filters) as FilterName[]).forEach(key => {
			commit('SET_FILTER', { key, value: INITIAL_FILTERS[key] });
		});
	},
};

// MUTATIONS
const mutations: MutationTree<typeof state> = {
	SET_FILTER(state, payload: { key: keyof FilterCollection; value: Partial<FilterCollection> }) {
		(state.filters as any)[payload.key] = payload.value;
	},
	SET_FETCHING(state, payload: boolean) {
		state.isFetching = payload;
	},
};

export type PlotRecommenderState = typeof state;

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
